import { graphql } from 'react-relay';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import type {
	usePreloadCommentButtonQuery$data,
	usePreloadCommentButtonQuery$variables,
} from './__generated__/usePreloadCommentButtonQuery.graphql.ts';

const usePreloadCommentButtonQuery = graphql`
	query usePreloadCommentButtonQuery($pageId: ID!) {
		comments(pageId: $pageId, type: UNRESOLVED, depth: ALL) {
			count
			nodes {
				id
				location {
					type
					... on InlineComment {
						inlineMarkerRef
					}
				}
			}
		}
		content(id: $pageId) {
			nodes {
				id
				properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
				metadata {
					frontend {
						fabricEditorSupported
					}
				}
			}
		}
	}
`;

export const usePreloadCommentButton = (
	contentId: string,
	isCommentButtonSSRd: boolean,
): {
	data: {
		commentData: usePreloadCommentButtonQuery$data | undefined;
	};
	error: ApolloErrorInterop | undefined;
} => {
	const { data: commentData, error: commentError } = useQueryInterop<
		usePreloadCommentButtonQuery$data,
		usePreloadCommentButtonQuery$variables
	>(usePreloadCommentButtonQuery, {
		fetchPolicy: isCommentButtonSSRd ? 'cache-first' : 'cache-and-network',
		variables: { pageId: contentId },
	});

	return {
		data: { commentData },
		error: commentError,
	};
};
